<template>
  <div
    class="popup"
    :style="{ visibility: show ? 'unset' : 'hidden' }"
    ref="pop"
  >
    <div class="top" v-if="!mobile">
      <button @click="close">
        <img src="@/assets/images/icons/close.svg" alt="close" />
      </button>
    </div>
    <div class="mobile-header" v-if="mobile">
      <div class="title">
        Новое бронирование
      </div>
      <button @click="close">
        <img src="@/assets/images/icons/close.svg" alt="close" />
      </button>
    </div>
    <chose-workplace
      v-if="showWorkplaces && chosenZone"
      :zones="types"
      :background="chosenZone.plan_image"
      :overflow="chosenZone.plan_image"
      :isOpen="showWorkplaces"
      :start="startAt"
      :end="endAt"
      :coworkingId="chosenCoworking.id"
      :zone-id="chosenZone.id"
      :chosenCircle="form.workplaces"
      @submit="showWorkplaces = false"
      @close="showWorkplaces = false"
      @choseCircle="(v) => form.workplaces.push(v)"
      @removeCircle="
        (v) => (form.workplaces = form.workplaces.filter((val) => val !== v))
      "
    />
    <custom-select
      mb="10px"
      max-width="100%"
      placeholder="Коворкинг*"
      @change="form.cowork = $event"
      :value="(form.cowork = coworking[0].id)"
    >
      <option
        v-for="({ id, name }, i) in coworking"
        :value="id"
        :key="i + 'cowork'"
      >
        {{ name }}
      </option>
    </custom-select>
    <transition name="fade">
      <div v-if="form.cowork">
        <div class="date">
          Работает с <b>{{ chosenCoworking.start_at }}</b> до
          <b>{{ chosenCoworking.end_at }}</b>
        </div>
        <custom-select
          mb="10px"
          max-width="100%"
          placeholder="Тип*"
          @change="form.type = $event"
          :value="form.type"
          v-if="form.cowork"
        >
          <option v-for="(type, i) in types" :value="type.id" :key="i + 'type'">
            {{ type.name }}
          </option>
        </custom-select>
      </div>
    </transition>
    <div class="date">{{ $moment(form.date).format("ddd, DD MMMM") }}</div>
    <div v-if="mobile">
      <CustomInput mb="10px" v-model="form.date" type="date" />
    </div>
    <div class="timepicker">
      <div class="inp">
        <CustomInput type="time" step="1800" v-model="form.start" />
      </div>
      <span class="strip">-</span>
      <div class="inp">
        <CustomInput type="time" step="1800" v-model="form.end" />
      </div>
    </div>
    <button-component
      :loading="confirming"
      v-if="canConfirm"
      @click="submit()"
      width="100%"
      >Подтвердить</button-component
    >
    <button
      class="save"
      @click="emitFunc"
      :disabled="!canOpenWorkplaces"
      v-if="!canConfirm"
    >
      Перейти к выбору места
    </button>
  </div>
</template>

<script>
import ButtonComponent from "@/components/ui/buttons/button-component";
import ChoseWorkplace from "@/components/Calendar/Calendar_Place_Chose_Modal";
import CustomInput from "@/components/ui/inputs/custom-input";
import CustomSelect from "@/components/ui/inputs/custom-select";
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  name: "createRWModal",
  components: { CustomSelect, CustomInput, ChoseWorkplace, ButtonComponent },
  props: {
    coworking: Array,
  },
  data: () => ({
    confirming: false,
    showWorkplaces: false,
    mobile: false,
    form: {
      date: "",
      edate: "",
      start: "",
      end: "",
      title: "",
      type: "",
      cowork: "",
      workplaces: [],
    },
    show: false,
    coords: {
      left: 0,
      right: 0,
    },
    errors: {},
  }),
  computed: {
    canConfirm() {
      return this.canOpenWorkplaces && this.form.workplaces.length;
    },
    types() {
      return this.coworking
        .filter((val) => val.id === parseInt(this.form.cowork))
        .map((val) => val.zones)[0];
    },
    canOpenWorkplaces() {
      return (
        this.form.type &&
        this.form.cowork &&
        this.form.start &&
        this.form.end &&
        this.form.date
      );
    },
    chosenZone() {
      if (!this.types) return null;
      return this.types.filter((val) => parseInt(this.form.type) === val.id)[0];
    },
    chosenCoworking() {
      return this.coworking.filter(
        (val) => parseInt(this.form.cowork) === val.id
      )[0];
    },
    startAt() {
      let time = this.form.start.split(":");
      return this.form.start && this.form.date
        ? moment(this.form.date)
            .set("hours", time[0])
            .set("minutes", time[1])
            .format("YYYY-MM-DD HH:mm:ss")
        : null;
    },
    endAt() {
      let time = this.form.end.split(":");
      return this.form.end && this.form.edate
        ? moment(this.form.edate)
            .set("hours", time[0])
            .set("minutes", time[1])
            .format("YYYY-MM-DD HH:mm:ss")
        : null;
    },
  },
  mounted() {
    if (!this.coworking.length)
      this.$toast.error("Список доступных коворкингов пуст!");
  },
  methods: {
    ...mapMutations(["openModal", "setModalData"]),
    open(e, edit = false) {
      if (e != undefined && moment(e.startStr).diff(moment(), "minutes") <= 0)
        return this.$toast.error(
          "Невозможно создать аренду на прошедшую дату!"
        );
      this.clear();
      if (window.innerWidth < 425) {
        this.mobile = true;
        this.$refs.pop.style.left = "0px";
        this.$refs.pop.style.bottom = "0px";
      } else {
        //offsets section
        this.mobile = false;
        let w = this.$refs.pop.offsetWidth;
        let h = this.$refs.pop.offsetHeight;
        let left = Math.abs(
          e.jsEvent.x - e.jsEvent.layerX + e.jsEvent.target.clientWidth + w
        );
        let ofset = 10;
        let lofSet = document.body.clientWidth - left;
        if (lofSet > 0) {
          lofSet = ofset;
        } else {
          lofSet = -e.jsEvent.target.clientWidth - w - ofset;
        }
        left -= 365;
        let scrY = window.scrollY;
        if (
          document.body.offsetHeight <
          e.jsEvent.y - e.jsEvent.layerY + window.scrollY + h
        )
          scrY = -h + e.jsEvent.target.clientHeight + window.scrollY;
        //offsets end
        //coords section
        this.$refs.pop.style.left = left + lofSet + "px";
        this.$refs.pop.style.top =
          Math.abs(e.jsEvent.y - e.jsEvent.layerY + scrY) + "px";
        //coords end
      }
      // if (e == undefined) {
      //   if (this.$moment().diff(this.$moment().hour(21).minute(30).second(0).millisecond(0), 'hours') < 1) {
      //     console.log(this.$moment().get('minute'))
      //     e = {}
      //     e.start = this.$moment().get('minute') >= 30 ? this.$moment().minute(0).second(0).add(1, "hour").toDate() : this.$moment().minute(30).second(0).toDate()
      //     e.end = this.$moment(e.start).add(30, 'minute').toDate()
      //   } else {
      //     return this.$toast.error('На сегодня уже нельзя создать заявку');
      //   }
      // }
      if (edit) {
        this.form.date = this.$moment(e.start).format("YYYY-MM-DD");
        this.form.start = this.$moment(e.start).format("HH:mm");
        this.form.end = this.$moment(e.end).format("HH:mm");
        this.form.title = "";
        this.form.price = "";
        this.form.client = "";
      } else if (e) {
        this.form.date = this.$moment(e.start).format("YYYY-MM-DD");
        this.form.edate = this.$moment(e.end).format("YYYY-MM-DD");
        this.form.start = this.$moment(e.start).format("HH:mm");
        this.form.end = this.$moment(e.end).format("HH:mm");
      }
      this.$emit("opened");
      this.show = true;
    },
    clear() {
      this.form = {
        date: "",
        edate: "",
        start: "",
        end: "",
        title: "",
        type: "",
        cowork: "",
        workplaces: [],
      };
    },
    close() {
      this.show = false;
    },
    submit() {
      this.confirming = true;
      this.$api.master.rent
        .create([
          {
            coworking_id: this.form.cowork,
            start_at: this.startAt,
            end_at: this.endAt,
            zone_id: this.form.type,
            workplaces: this.form.workplaces,
          },
        ])
        .then(({ data }) => {
          this.$toast.success("Забронировано! Перенаправляем на оплату");
          this.openModal("rent_checkout");
          this.setModalData({ data });
          this.$emit("create", this.form);
          this.close();
        })
        .catch(({ response }) => {
          if (response.data.exception && response.data.message)
            this.$toast.error(response.data.message);
          if (
            response.data.errors &&
            response.data.errors[Object.keys(response.data.errors)]
          )
            this.$toast.error(
              response.data.errors[Object.keys(response.data.errors)][0]
            );
        })
        .finally(() => (this.confirming = false));
    },
    emitFunc() {
      this.validateWorkTime()
        .then(() => (this.showWorkplaces = true))
        .catch((e) => {
          console.log(e);
          this.$toast.error(e.message);
        });
    },
    validateWorkTime() {
      return new Promise((resolve, reject) => {
        let startWorkCoworking = this.$moment(
          `${this.form.date} ${this.chosenCoworking.start_at}`,
          "YYYY-MM-DD HH:mm"
        ).toDate();
        let endWorkCoworking = this.$moment(
          `${this.form.date} ${this.chosenCoworking.end_at}`,
          "YYYY-MM-DD HH:mm"
        ).toDate();
        let startSelected = this.$moment(
          this.startAt,
          "YYYY-MM-DD HH:mm"
        ).toDate();
        let endSelected = this.$moment(this.endAt, "YYYY-MM-DD HH:mm").toDate();
        if (startSelected > Date.now()) {
          if (
            startWorkCoworking <= startSelected &&
            endWorkCoworking >= endSelected
          )
            return resolve();
          else {
            let message;
            if (startWorkCoworking > startSelected) {
              message = `Выбранный коворкинг работает с ${this.chosenCoworking.start_at}`;
            }
            if (endWorkCoworking < endSelected) {
              message = `Выбранный коворкинг работает до ${this.chosenCoworking.end_at}`;
            }
            if (
              startWorkCoworking > startSelected &&
              endWorkCoworking < endSelected
            ) {
              message = `Выбранный коворкинг работает с ${this.chosenCoworking.start_at} до ${this.chosenCoworking.end_at}`;
            }
            return reject({ message });
          }
        } else {
          reject({ message: "Начальное время уже прошло." });
        }
      });
    },
  },
  watch: {
    "form.date"(n) {
      if (this.mobile) {
        this.form.edate = n;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  display: inline-block;
  z-index: 100;
  position: absolute;
  left: 0;
  top: 230px;
  background-color: #ffffff;
  border: 2px solid #ffd2b4;
  border-radius: 5px;
  padding: 15px 20px 20px 20px;
  max-width: 365px;
  width: 100%;
  //overflow: hidden;
}

.mobile-header {
  border-radius: 10px 10px 0 0;
  background: #dbbfa7;
  height: 50px;
  position: absolute;
  left: 0;
  right: 0;
  top: -49px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px;

  &.title {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #383838;
  }

  & button {
    background-color: transparent;
    border: none;
    width: 20px;
    height: 20px;

    img {
      max-width: 100%;
    }
  }
}

.top {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;

  button {
    background-color: transparent;
    border: none;
    width: 20px;
    height: 20px;

    img {
      max-width: 100%;
    }
  }
}

.date {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.7;
  color: #808080;
  margin-bottom: 10px;
}

.timepicker {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .inp {
    width: 100px;
  }

  .strip {
    margin: 0 5px;
  }
}

.name {
  position: relative;

  &__dropdown {
    z-index: 2;
    position: absolute;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04),
      0 0 1px rgba(0, 0, 0, 0.04);
    right: 0;
    left: 0;
    top: 52px;
    border: 1px solid #dbbfa7;
    border-radius: 5px;
    overflow: hidden;

    &-item {
      display: flex;
      align-items: center;
      padding: 10px 15px;
      border-bottom: 1px solid #e5e5e5;
      background-color: #fff;
      cursor: pointer;

      img {
        margin-right: 10px;
      }

      .title {
        font-size: 16px;
        line-height: 1.5;
        color: #383838;
      }

      .phone {
        font-size: 14px;
        line-height: 1.7;
        color: #808080;
      }
    }
  }
}

.save {
  height: 48px;
  margin-left: -22px;
  margin-right: -22px;
  width: calc(100% + 44px);
  margin-bottom: -2px;
  transform: translateY(20px);
  border: 2px solid #dbbfa7;
  background-color: #fff;
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #808080;
}

@media (max-width: 425px) {
  .popup {
    max-width: 100%;
    position: fixed;
    left: 0 !important;
    top: unset !important;
    bottom: 0;
    right: 0;
    border: unset;
  }

  .save {
    width: 100%;
    border-radius: 5px;
    border: unset;
    background-color: #dbbfa7;
    color: #383838;
    margin: 15px auto;
  }
}
</style>
